module.exports = __webpack_public_path__ + "img/phone.1e4dfbde.png";